// Un monigote en su propio lienzo pequeño, para cuando tiene que moverse por encima de la escena: el que va colgando del
// puntero al arrastrar (Fantasma) y los de la sala en «Ordenar», que tiemblan enteros como un icono del iPhone. Mismo
// arte y mismo zoom entero que el lienzo grande (Lienzo.tsx), que entonces no los pinta.
import { memo, useEffect, useRef } from 'react';
import { persona, retratoDe, type Animacion } from '../../../lib/oficina/pixel-art';
import { cn } from '../../../lib/utils';

export const Monigote = memo(function Monigote({
  semilla,
  animacion,
  z,
  ancho,
  alto,
  x,
  y,
  dePie = false,
  className,
}: {
  semilla: string;
  animacion: Animacion;
  z: number;
  /** Tamaño del lienzo, en píxeles de arte: lo que asome por abajo se recorta (la mesa tapa el resto). */
  ancho: number;
  alto: number;
  /** Dónde va el monigote dentro de su lienzo (centro de la cabeza a lo ancho, borde de arriba de la cara). */
  x: number;
  y: number;
  dePie?: boolean;
  className?: string;
}) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const ctx = ref.current?.getContext('2d');
    if (!ctx) return;
    ctx.imageSmoothingEnabled = false;
    ctx.setTransform(z, 0, 0, z, 0, 0);
    ctx.clearRect(0, 0, ancho, alto);
    persona(ctx, x, y, retratoDe(semilla), animacion, 1, dePie);
  }, [semilla, animacion, z, ancho, alto, x, y, dePie]);
  return <canvas ref={ref} width={ancho * z} height={alto * z} className={cn('[image-rendering:pixelated]', className)} aria-hidden />;
});
